import { Link, useLocation } from 'react-router-dom';
import { useState } from 'react';
import { Menu, X } from 'lucide-react';

const navLinks = [
  { label: 'Home', path: '/' },
  { label: 'About', path: '/about' },
  { label: 'Experience', path: '/projects' },
  { label: 'Current Lore', path: '/current-lore' },
  { label: 'mbk studio', path: '/ai-studio', isNew: true },
  { label: 'Journal', path: '/journal' },
  { label: 'Archives', path: '/archives' },
  { label: 'Research', path: '/research' },
];

export default function Navbar() {
  const location = useLocation();
  const [open, setOpen] = useState(false);

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 flex items-center justify-between px-8 py-5 bg-background/70 backdrop-blur-xl border-b border-border">
      <Link to="/" className="relative text-foreground text-xl font-bold tracking-tight" style={{ fontFamily: 'Syne, sans-serif' }}>
        <span className="absolute inset-0 blur-md bg-primary/30 rounded-full animate-pulse" />
        <span className="relative"><span style={{ color: 'hsl(var(--primary))' }}>m</span>bk</span>
      </Link>

      {/* Desktop nav */}
      <div className="hidden md:flex items-center gap-8">
        {navLinks.map(link => {
          const active = location.pathname === link.path;
          return (
            <Link
              key={link.path}
              to={link.path}
              className={`text-sm font-semibold transition-all duration-200 relative group inline-flex items-center gap-1.5 ${
                active ? 'text-primary' : 'text-muted-foreground hover:text-foreground'
              }`}
            >
              {link.label}
              {link.isNew && (
                <span className="relative inline-flex">
                  <span className="absolute inset-0 rounded-full bg-violet-500/50 blur-[3px] animate-pulse" />
                  <span className="relative text-[7px] font-bold tracking-[0.12em] px-1 py-[1px] rounded-full bg-gradient-to-br from-violet-600 to-purple-500 text-white shadow-[0_0_8px_rgba(139,92,246,0.55)] border border-white/15">
                    NEW
                  </span>
                </span>
              )}
              <span className={`absolute -bottom-1 left-0 h-px bg-primary transition-all duration-300 ${active ? 'w-full' : 'w-0 group-hover:w-full'}`} />
            </Link>
          );
        })}
      </div>

      {/* Mobile */}
      <button className="md:hidden text-muted-foreground" onClick={() => setOpen(!open)}>
        {open ? <X size={20} /> : <Menu size={20} />}
      </button>

      {open && (
        <div className="absolute top-full left-0 right-0 bg-card border-b border-border px-8 py-6 flex flex-col gap-4 md:hidden">
          {navLinks.map(link => (
            <Link key={link.path} to={link.path} onClick={() => setOpen(false)}
              className={`text-sm font-semibold inline-flex items-center gap-2 ${location.pathname === link.path ? 'text-primary' : 'text-muted-foreground'}`}>
              {link.label}
              {link.isNew && (
                <span className="text-[7px] font-bold tracking-[0.12em] px-1 py-[1px] rounded-full bg-gradient-to-br from-violet-600 to-purple-500 text-white border border-white/15">
                  NEW
                </span>
              )}
            </Link>
          ))}
        </div>
      )}
    </nav>
  );
}